import * as React from 'react';
import { Wrapper as Label } from '../Label/Label';
import { rem } from 'polished';
import FormGroupContext from './FormGroupContext';
import styled from 'styled-components';
import uniqueId from 'lodash.uniqueid';
const Wrapper = styled.div `
  margin-bottom: ${({ theme }) => rem(theme.formGroup.bottomMargin)};
  > ${Label} {
    margin-bottom: ${({ theme }) => rem(theme.formGroup.labelGutter)};
  }
`;
const FormGroup = ({ className, children }) => {
    const [id] = React.useState(uniqueId());
    return (React.createElement(FormGroupContext.Provider, { value: { id } },
        React.createElement(Wrapper, null, children)));
};
export default FormGroup;
